import { FormFieldTypes } from "../../../data/formFieldType";

export const GenerateInvoiceData = {
    name: "AdditionalInfo",
    initialState: {
        searchByCompanyName: "",
        searchByApplicationNumber: "",
        searchByCertificateNumber: "",
    },
    formFields: [
        {
            id: "searchByCompanyName",
            lable: "Search by Company Name",
            Field_Name: "Search by Company Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "searchByCompanyName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-4 mb-3",
            },
        },
      
        {
            id: "searchByApplicationNumber",
            lable: "Search by Application Number",
            Field_Name: "Search by Application Number",
            fieldType: FormFieldTypes.INPUT,
            dataField: "searchByApplicationNumber",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-4 mb-3",
            },
        },
        {
            id: "searchByCertificateNumber",
            lable: "Search by Certificate Number",
            Field_Name: "Search by Certificate Number",
            fieldType: FormFieldTypes.INPUT,
            dataField: "searchByCertificateNumber",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-4 mb-3",
            },
        },
    ],
    formSetting: {
        isViewOnly: false,
    },
};
